import { render, staticRenderFns } from "./centerMemberDialogList.vue?vue&type=template&id=03bbb907&scoped=true&"
import script from "./centerMemberDialogList.vue?vue&type=script&lang=js&"
export * from "./centerMemberDialogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bbb907",
  null
  
)

export default component.exports